/**
 * Maps the many ways `/v1/users/self` reports a company's
 * `applicationVersion` to a normalized ISO 3166-1 alpha-2 country code.
 *
 * Anything unmapped (or `"other"`) falls back to `"INT"` (internacional).
 */
export const countriesMapping: Record<string, string> = {
  Argentina: 'AR',
  argentina: 'AR',
  ARG: 'AR',
  AR: 'AR',
  Colombia: 'CO',
  colombia: 'CO',
  COL: 'CO',
  CO: 'CO',
  'Costa Rica': 'CR',
  CostaRica: 'CR',
  costaRica: 'CR',
  CRI: 'CR',
  CR: 'CR',
  España: 'ES',
  españa: 'ES',
  spain: 'ES',
  ESP: 'ES',
  ES: 'ES',
  México: 'MX',
  Mexico: 'MX',
  méxico: 'MX',
  mexico: 'MX',
  MEX: 'MX',
  MX: 'MX',
  Panamá: 'PA',
  Panama: 'PA',
  panamá: 'PA',
  panama: 'PA',
  PAN: 'PA',
  PA: 'PA',
  Perú: 'PE',
  Peru: 'PE',
  perú: 'PE',
  peru: 'PE',
  PER: 'PE',
  PE: 'PE',
  republicaDominicana: 'DO',
  RepublicaDominicana: 'DO',
  'republica Dominicana': 'DO',
  'Republica Dominicana': 'DO',
  Dominicana: 'DO',
  dominicana: 'DO',
  DOM: 'DO',
  DO: 'DO',
  Venezuela: 'VE',
  venezuela: 'VE',
  VEN: 'VE',
  VE: 'VE',
  other: 'INT',
  Other: 'INT',
  OTHER: 'INT',
  INT: 'INT',
}
